import styled from 'styled-components';
import { SuiSlide, SuiInfiniteScroll } from '@splashthat/sui';

export const Slide = styled(SuiSlide)`
    height: 100%;
    width: 100%;
    overflow: hidden;
`;

export const InfiniteScrollContainer = styled(SuiInfiniteScroll)`
    overflow: scroll;
    flex-wrap: wrap;

    .SuiContainer {
        display: flex;
        flex-wrap: wrap;
    }
`;

export const Gif = styled.img`
    position: relative;
    flex-grow: 1;
    width: 33%;
    height: 25%;
    min-height: 200px;
    object-fit: cover;
    background-color: ${({ theme }) => theme.palette.grayscale.gray10};
    cursor: pointer;
    border: solid 2px ${({ theme }) => theme.palette.grayscale.gray2};

    &:hover {
        box-shadow: 0 0 0 2px ${({ theme }) => theme.palette.primary.main} inset;
    }
`;
